import { api, webApi } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getWarehouseList({
    cursor = '',
    latitude = '',
    limit = '',
    longitude = '',
    q = '',
    status = '',
  } = {}) {
    const params = {
      cursor,
      latitude,
      limit,
      longitude,
      q,
      status,
    };
    return api.get('/warehouses', { params: omitBy(params, isNil) });
  },
  getWarehouseDetail(warehouseId) {
    return api.get(`/warehouses/${warehouseId}`);
  },
  getDefaultWarehouse() {
    return webApi.get('/warehouses/default');
  },
  activateWarehouse(id) {
    return api.put(`/warehouses/${id}/reactivate`);
  },
  deactivateWarehouse(id) {
    return api.delete(`/warehouses/${id}`);
  },
  deleteWarehouse(id) {
    return api.delete(`/warehouses/${id}/delete`);
  },
  createWarehouse(warehouse = {}) {
    return api.post('/warehouses', warehouse);
  },
  updateWarehouse(id, warehouse = {}) {
    return api.put(`/warehouses/${id}`, warehouse);
  },
  setPrimaryWarehouse(id) {
    return api.post(`/warehouses/${id}/set_primary`);
  },
};
